import { Link, useLocation } from 'react-router-dom';
import { Channel, EPermissions } from "../../../types/working-model";
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from '../../general-ui/icon';
import './sidebar-nav.scss';
import { AuthWrapper } from "../authentication/AuthWrapper";
import { PATHNAMES } from "../../../utils/admin-routing-utils";
import WaitingIndicator from "../../general-ui/waiting-indicator/waiting-indicator";
import { useTypedSelector } from "../../../store/reducers/use-typed-selector";
import ChannelSelectionDropdown from "./channel-selection-dropdown";

interface AdminNavProps {
	currentChannel?: Channel;
}

export default function AdminNav({ currentChannel }: AdminNavProps): JSX.Element {
	const user = useTypedSelector(state => state.AuthReducer.user);
	const location = useLocation();
	const { pathname } = location;

	return user ? (
		<div className="admin-nav">
			<ChannelSelectionDropdown currentChannel={currentChannel} />

			<nav>
				<AuthWrapper allowedRoles={[EPermissions.Moderation, EPermissions.Producer, EPermissions.Sitebuilder, EPermissions.GroupAdmin, EPermissions.Viewer]}>
					<Link className={classNames({ active: pathname === PATHNAMES.Events })} to={PATHNAMES.Events}>
						<div className="icon"><Icon name={ICONS.EVENTS_NAV} size={24} color={pathname === PATHNAMES.Events ? COLORS.WHITE : COLORS.MED_LIGHT_GRAY} /></div>
						Events
					</Link>
				</AuthWrapper>
				<AuthWrapper allowedRoles={[EPermissions.Analytics]}>
					<Link className={classNames({ active: pathname.startsWith(PATHNAMES.AnalyticsLink) })} to={PATHNAMES.AnalyticsLink}>
						<div className="icon"><Icon name={ICONS.ANALYTICS_NAV} size={24} color={pathname.startsWith(PATHNAMES.AnalyticsLink) ? COLORS.WHITE : COLORS.MED_LIGHT_GRAY} /></div>
						Analytics
					</Link>
				</AuthWrapper>
				<AuthWrapper allowedRoles={[EPermissions.PasscodeManager]}>
					<Link className={classNames({ active: pathname === PATHNAMES.People })} to={PATHNAMES.People}>
						<div className="icon"><Icon name={ICONS.PEOPLE_NAV} size={24} color={pathname === PATHNAMES.People ? COLORS.WHITE : COLORS.MED_LIGHT_GRAY} /></div>
						People
					</Link>
				</AuthWrapper>
				<AuthWrapper
					allowedRoles={[EPermissions.Sitebuilder, EPermissions.GroupAdmin]}
				>
					<Link className={classNames({ active: pathname.includes(PATHNAMES.Content) })} to={PATHNAMES.ContentSubLevels.Documents.All}>
						<div className="icon"><Icon name={ICONS.CONTENT_NAV} size={24} color={pathname.includes(PATHNAMES.Content) ? COLORS.WHITE : COLORS.MED_LIGHT_GRAY} /></div>
						Content
					</Link>
				</AuthWrapper>
				<AuthWrapper
					allowedRoles={[EPermissions.Sitebuilder, EPermissions.GroupAdmin]}
				>
					<Link className={classNames({ active: pathname === PATHNAMES.Products })} to={PATHNAMES.Products}>
						<div className="icon"><Icon name={ICONS.PRODUCTS_NAV} size={24} color={pathname === PATHNAMES.Products ? COLORS.WHITE : COLORS.MED_LIGHT_GRAY} /></div>
						Products
					</Link>
				</AuthWrapper>
			</nav>
		</div>
	) : (
		<WaitingIndicator minHeight={'90vh'} fillSpace={true} />
	);
}